export var EColumnType;
(function (EColumnType) {
    EColumnType[EColumnType["ONE"] = 1] = "ONE";
    EColumnType[EColumnType["TWO"] = 2] = "TWO";
    EColumnType[EColumnType["RECOMMEND"] = 3] = "RECOMMEND";
})(EColumnType || (EColumnType = {}));
